module.exports = __webpack_public_path__ + "media/1x1/ua-841d259d.svg";